import React from "react";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import IcBronzeCheck from "../../resources/svgs/ic_bronze_check.svg";

import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser';

import SmartLink from "../links/smart_link.js";
import IFrame from "../components/iframe.js";

import { YouTubeEmbeddingWidth, YouTubeEmbeddingHeight, YouTubeEmbeddingProp } from "../../constants.js";

const bulletSizeDesktop = 20;
const bulletSizeMobile  = 15;

const styles = theme => ({
  root: {
    display: "block",
    // Customize text
    "& p": {
      marginTop: "0px",
      marginBottom: "20px"
    },
    "& p:last-child": {
      marginBottom: "0px"
    },
    // Customize lists
    "& ul, & ol": {
      paddingLeft: "45px",
      ['@media (max-width: 768px)']: {
        paddingLeft: "25px",
      }
    },
    "& ol li, & ul li": {
      marginBottom: "5px !important",
    },
    "& ul li:last-child, & ol li:last-child": {
      marginBottom: "0px"
    },
    "& ul li": {
      position: "relative",
      listStyleType: "none",
      minHeight: `${bulletSizeDesktop}px`
    },
    "& ul li:before": {
      content: '" "',
      position: "absolute",
      backgroundImage: `url(${IcBronzeCheck})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: `${bulletSizeDesktop}px ${bulletSizeDesktop}px`,
      backgroundPosition: "center",
      width: `${bulletSizeDesktop}px`,
      height: `${bulletSizeDesktop}px`,
      left: `-${bulletSizeDesktop + 10}px`,
      top: "4px",
      ['@media (max-width: 768px)']: {
        top: "2px",
        width: `${bulletSizeMobile}px`,
        height: `${bulletSizeMobile}px`,
        left: `-${bulletSizeMobile + 7}px`,
        backgroundSize: `${bulletSizeMobile}px ${bulletSizeMobile}px`
      },
    },
    // Customize images
    "& figure.image": {
      ['@media (max-width: 768px)']: {
        float: `none !important`,
        maxWidth: "100% !important",
        margin: "8px 0px !important",
      }
    },
    // Customize tables
    "& figure.table": {
      ['@media (max-width: 992px)']: {
        float: `none !important`,
        width: "100% !important",
        maxWidth: "100% !important",
        margin: "10px 0px !important",
        padding: "0px !important"
      }
    },
    "& figure.table[style*='float:left'], figure.table[style*='float: left']": {
      paddingLeft: "0px",
      paddingRight: "15px"
    },
    "& figure.table[style*='float:right'], figure.table[style*='float: right']": {
      paddingLeft: "15px",
      paddingRight: "0px"
    },
    "& figure.table table": {
      borderCollapse: "collapse",
      borderSpacing: "0",
      ['@media (max-width: 992px)']: {
        tableLayout: "fixed",
      }
    },
    "& figure.table table td": {
      ['@media (max-width: 992px)']: {
        wordBreak: "break-word",
      }
    },
    // Clear both at the end of content
    "&:after": {
      content: "''",
      clear: "both",
      display: "table"
    },
  },
  embeddedContainer: {
    display: "flex",
    justifyContent: "center"
  },
  embeddedIframeContainer: {
    maxWidth: "100%",
    "& div": {
      position: "relative",
      width: YouTubeEmbeddingWidth,
      paddingBottom: YouTubeEmbeddingProp,
      maxWidth: "100%",
      height: "0",
    }
  },
  embeddedIframe: {
    width: "100%",
    height: "100%",
    position: "absolute",
    left: "0"
  }
});

/**
 * Component for display html string (for example content of WYSIWYG inputs)
 * @name HtmlContent
 * @param {object} props React component properties
 * @param {string} [props.className] CSS-class of container
 * @example
 * return (
 *  <HtmlContent className = { "content-class" } >
 *    { "<a href=\"https://google.com\" target=\"_blank\"><b>GOOGLE IT!</b></a>" }
 *  </HtmlContent>
 * )
*/
class HtmlContent extends React.Component {

  getYouTubeId(url) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
        return match[2];
    } else {
        return undefined;
    }
  }

  transform = (node, index) => {
    const { classes } = this.props;
    if(node.type === "tag" && node.name === "a") {
      return <SmartLink to = { node.attribs.href }
                        target = { node.attribs.target }
                        key = { index } >
        { 
          node.children.map((child, index) => {
            return convertNodeToElement(child, index, this.transform)
          })
        }
      </SmartLink>
    }
    if(node.type === "tag" && node.name === "oembed") {
      let id = this.getYouTubeId(node.attribs.url);
      if(!id) {
        return undefined;
      }

      return <div className = { classes.embeddedContainer }
                  key = { index } >
          <IFrame width = { YouTubeEmbeddingWidth }
                  height = { YouTubeEmbeddingHeight }
                  src= { `//www.youtube.com/embed/${id}` }
                  className = { classes.embeddedIframeContainer }
                  iframeClass = { classes.embeddedIframe } />
      </div>
      
    }
    return undefined;
  }

  render() {
    const { classes, className } = this.props;
    
    const { children } = this.props;
    return <span className = { clsx(classes.root, className, "ck-content") }>
      { 
        children && 
        ReactHtmlParser(children, {
          transform: this.transform
        }) 
      }
    </span>
  }
}

HtmlContent.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string
};

export default withStyles(styles)(HtmlContent);